import { ReactNode, useMemo } from 'react';
import InteractiveButton from '../../../components/InteractiveButton/InteractiveButton';
import { ACTIVE_TAB_STYLES, COMMON_TAB_STYLES, INACTIVE_TAB_STYLES } from '../constants';

export interface TabButtonProps {
  onClick?: () => void;
  isActive?: boolean;
  text?: string | ReactNode;
}

export const TabButton = ({ onClick, isActive, text }: TabButtonProps) => {
  const custonType = useMemo(() => {
    if (isActive) {
      return ACTIVE_TAB_STYLES;
    }

    return INACTIVE_TAB_STYLES;
  }, [isActive]);

  return (
    <InteractiveButton className='text-nowrap' onClick={onClick} customType={`${COMMON_TAB_STYLES} ${custonType}`} style={{ padding: '8px' }}>
      {text}
    </InteractiveButton>
  );
};
